// Cmd/Ctrl+K: every action of the map as a typed command, and the keys that
// reach the same actions without the palette.

import { esc } from './panel.js';

export function createPalette(ctx) {
  const { t } = ctx;
  const root = document.getElementById('atlasPalette');
  const input = root.querySelector('input');
  const list = root.querySelector('ul');
  let items = [], cursor = 0, mode = null;

  const base = () => [
    { id: 'find', label: t('cmd.find'), run: () => enterMode('find') },
    { id: 'place', label: t('cmd.place'), run: () => enterMode('place') },
    { id: 'lang', label: t('cmd.lang'), run: () => enterMode('lang') },
    { id: 'near', label: t('cmd.near'), key: 'N', run: ctx.actions.near },
    { id: 'fit', label: t('cmd.fit'), key: 'F', run: ctx.actions.fit },
    { id: 'labels', label: t('cmd.labels'), key: 'L', run: ctx.actions.labels },
    { id: 'heat', label: t('cmd.heat'), key: 'H', run: ctx.actions.heat },
    { id: 'clear', label: t('cmd.clear'), run: ctx.actions.clear },
    { id: 'share', label: t('cmd.share'), run: ctx.actions.share },
    ...(ctx.actions.hasSelection() ? [{ id: 'open', label: t('cmd.open'), run: ctx.actions.open }, { id: 'dir', label: t('cmd.dir'), run: ctx.actions.directions }] : []),
  ];

  function enterMode(m) {
    mode = m; input.value = ''; input.placeholder = m === 'find' ? t('cmd.find') : m === 'place' ? t('cmd.place') : t('cmd.lang');
    refresh();
  }

  function refresh() {
    const q = input.value.trim().toLowerCase();
    if (mode) {
      const groups = ctx.search(q || ' ', 8);
      const want = mode === 'find' ? 'churches' : mode === 'place' ? 'places' : 'filters';
      const g = groups.find((x) => x.type === want);
      let found = g ? g.items : [];
      if (mode === 'lang') found = found.filter((x) => x.type === 'lang');
      if (mode === 'lang' && !q) found = ctx.allLanguages();
      if (mode === 'place' && !q) found = ctx.topPlaces();
      items = found.map((it) => ({ id: it.type + ':' + (it.label), label: it.label, sub: it.sub || (it.count ? t('results.count', { n: it.count }) : ''), run: () => ctx.onPick(it) }));
    } else {
      items = base().filter((c) => !q || c.label.toLowerCase().includes(q));
    }
    cursor = 0;
    list.innerHTML = items.length ? items.map((c, i) => `<li><button type="button" role="option" data-i="${i}" class="${i === 0 ? 'is-active' : ''}"><span>${esc(c.label)}</span>${c.sub ? `<small>${esc(c.sub)}</small>` : ''}${c.key ? `<kbd>${c.key}</kbd>` : ''}</button></li>`).join('') : `<li class="atlas-palette-none">${esc(t('palette.none'))}</li>`;
  }
  function move(d) {
    if (!items.length) return;
    cursor = (cursor + d + items.length) % items.length;
    list.querySelectorAll('button').forEach((b, i) => b.classList.toggle('is-active', i === cursor));
    const active = list.querySelector('button.is-active'); if (active) active.scrollIntoView({ block: 'nearest' });
  }
  function run(i) { const c = items[i]; if (!c) return; const wasMode = mode; c.run(); if (!wasMode && mode) return; close(); }

  function open() { mode = null; input.value = ''; input.placeholder = t('palette.placeholder'); root.hidden = false; refresh(); input.focus(); }
  function close() { root.hidden = true; mode = null; }
  function toggle() { root.hidden ? open() : close(); }

  input.addEventListener('input', refresh);
  input.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
    else if (e.key === 'Enter') { e.preventDefault(); run(cursor); }
    else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); if (mode) { mode = null; input.value = ''; input.placeholder = t('palette.placeholder'); refresh(); } else close(); }
  });
  list.addEventListener('click', (e) => { const b = e.target.closest('[data-i]'); if (b) run(Number(b.dataset.i)); });
  root.addEventListener('click', (e) => { if (e.target === root) close(); });

  return { open, close, toggle, isOpen: () => !root.hidden };
}

/** Global keys. Typing in a field is never intercepted. */
export function bindKeys(ctx) {
  document.addEventListener('keydown', (e) => {
    const tag = (e.target && e.target.tagName) || '';
    const typing = tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (e.target && e.target.isContentEditable);
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); ctx.palette.toggle(); return; }
    if (e.key === 'Escape') { ctx.actions.escape(); return; }
    if (typing || e.metaKey || e.ctrlKey || e.altKey) return;
    switch (e.key) {
      case '/': e.preventDefault(); ctx.actions.search(); break;
      case 'f': case 'F': ctx.actions.fit(); break;
      case 'l': case 'L': ctx.actions.labels(); break;
      case 'h': case 'H': ctx.actions.heat(); break;
      case 'n': case 'N': ctx.actions.near(); break;
      case '?': ctx.actions.keys(); break;
      default: break;
    }
  });
}
